const center: Record<string, number> = {
  lat: 30.237165,
  lng: -93.232887
};

const zoom = 13;

const paths: Array<Record<string, number>> = [
  {
    lat: 30.221131,
    lng: -93.324609
  },
  {
    lat: 30.249435,
    lng: -93.298546
  },
  {
    lat: 30.256408,
    lng: -93.291385
  },
  {
    lat: 30.257771,
    lng: -93.217341
  },
  {
    lat: 30.248492,
    lng: -93.136743
  },
  {
    lat: 30.244612,
    lng: -93.133041
  },
  {
    lat: 30.237586,
    lng: -93.130795
  },
  {
    lat: 30.232919,
    lng: -93.167817
  },
  {
    lat: 30.226574,
    lng: -93.180805
  },
  {
    lat: 30.223428,
    lng: -93.191365
  },
  {
    lat: 30.228201,
    lng: -93.213578
  },
  {
    lat: 30.216821,
    lng: -93.233121
  },
  {
    lat: 30.213044,
    lng: -93.319363
  },
  {
    lat: 30.221131,
    lng: -93.324609
  }
];

export { center, zoom, paths };
